import { action, autorun, computed, makeObservable, observable } from 'mobx';
import { SocialModel } from './social.model';

export class LinkedSocialsStrote {
    socials: string[] = [];
    readonly socialControl = new SocialModel();
    readonly socailsControls: SocialModel[] = [];

    constructor() {
        makeObservable(
            this,
            {
                socials: observable,
                socailsControls: observable,
                setSocialsTypes: action,
                addSocial: action,
                removeSocial: action,
            },
            { autoBind: true }
        );
    }

    availableSocials(social: SocialModel) {
        const selected = [...this.socailsControls, this.socialControl]
            .map((c) => c.selectValue)
            .filter(Boolean);

        return this.socials.filter((s) => {
            return s === social.selectValue || !selected.includes(s);
        });
    }

    setSocialsTypes(socials: string[]): void {
        this.socials = socials;
    }

    addSocial(social: SocialModel = new SocialModel()): void {
        if (this.socailsControls.length < this.socials.length - 1) {
            this.socailsControls.push(social);
        }
    }

    removeSocial(id: string): void {
        const targetIdx = this.socailsControls.findIndex((s) => s.id === id);
        if (targetIdx >= 0) {
            this.socailsControls.splice(targetIdx, 1);
        }
    }
}
